import Vue from 'vue';
import Component from 'vue-class-component';
import REQ_URL from '@/consts/req-url';
import { MapData } from '@/types/map-data';
import { FALLBACK_FOOTER_CONTACT } from './TheMainFooter.data';

@Component({
})
export default class TheMainFooter extends Vue {
    mapData: MapData = FALLBACK_FOOTER_CONTACT

    get phones() {
        return this.mapData ? this.mapData['Основные данные'].Телефон.split(',<br/>') : [];
    }

    get email() {
        return this.mapData ? this.mapData['Основные данные']['E-mail'] : '';
    }

    async getCurrentRegionInfoData() {
        try {
            let data = await this.$fetch<MapData>(REQ_URL.CURRENT_REGION_INFO)
            if (data.body) this.mapData = data.body
        } catch (error) {
            return false
        }
        return true
    }

    async mounted() {
        await this.getCurrentRegionInfoData()
    }
}